import { render, staticRenderFns } from "./MessageInactiveViewSidebar.vue?vue&type=template&id=1e911caf&scoped=true"
import script from "./MessageInactiveViewSidebar.vue?vue&type=script&lang=js"
export * from "./MessageInactiveViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./MessageInactiveViewSidebar.vue?vue&type=style&index=0&id=1e911caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e911caf",
  null
  
)

export default component.exports